import * as React from 'react'

const IconAppwall = (isActive?, className?: string) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             className={className ? className : ''} width="48" height="70" viewBox="0 0 48 70">
            <g fill="none" fillRule="evenodd" stroke={isActive ? '#ff6262' : '#4A4A83'} strokeWidth=".849">
                <path d="M1 24.586l5.262-3.038 6.45 3.726v12.545l22.834 13.185v-6.469l5.262-3.037 6.45 3.725v20.948l-5.261 3.037L1 45.534z"/>
                <path d="M12.713 25.274l-5.32 3.075v12.549l5.32-3.076V25.274zM41.997 48.261l5.262-3.038"/>
                <path d="M1 24.586l6.45 3.726v12.545L35.547 57.08V44.535l6.45 3.726v20.947L1 45.534z"/>
                <path d="M19.231 3.507L23.573 1l8.526 4.923v22.212l6.198 3.58-10.462 7.027-4.341 2.507-10.46-19.11 4.262-2.461 1.935 1.117z"/>
                <path d="M19.231 25.718V3.507l8.526 4.923v22.211l6.199 3.58-10.462 7.028-10.46-19.11z"/>
                <path d="M32.099 5.923l-4.342 2.513V30.43l4.342-2.513z"/>
            </g>
        </svg>
    )
}

export default IconAppwall


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/svg/iconAppWall.tsx